import LANG from '../lang';

const supportedLanguages = Object.values(LANG).map(({ lng }) => lng);
const GOOGLE_TRANSLATE_STORAGE_KEY = 'google-translate-language';
const GOOGLE_TRANSLATE_COOKIE_NAME = 'googtrans';

export const getSupportedLanguage = (language) => {
	if (!language) return LANG.EN.lng;

	const normalizedLanguage = String(language).toLowerCase();
	if (supportedLanguages.includes(normalizedLanguage)) return normalizedLanguage;

	const baseLanguage = normalizedLanguage.split('-')[0];
	if (supportedLanguages.includes(baseLanguage)) return baseLanguage;

	return LANG.EN.lng;
};

const setGoogleTranslateCookie = (lang) => {
	const cookieValue = lang === LANG.EN.lng ? '/auto/en' : `/en/${lang}`;
	const cookie = `${GOOGLE_TRANSLATE_COOKIE_NAME}=${cookieValue};path=/`;
	document.cookie = cookie;

	if (window.location.hostname.includes('.')) {
		document.cookie = `${cookie};domain=.${window.location.hostname}`;
	}
};

const getGoogleTranslateCookieLanguage = () => {
	const matchedCookie = document.cookie
		.split('; ')
		.find((cookie) => cookie.startsWith(`${GOOGLE_TRANSLATE_COOKIE_NAME}=`));

	if (!matchedCookie) {
		return LANG.EN.lng;
	}

	const cookieValue = matchedCookie.split('=')[1] || '';
	const targetLanguage = cookieValue.split('/').pop();
	return getSupportedLanguage(targetLanguage);
};

export const syncGoogleTranslateLanguage = async (language) => {
	const nextLanguage = getSupportedLanguage(language);
	localStorage.setItem(GOOGLE_TRANSLATE_STORAGE_KEY, nextLanguage);
	setGoogleTranslateCookie(nextLanguage);
	return nextLanguage;
};

export const changeGoogleTranslateLanguage = async (language) => {
	const nextLanguage = getSupportedLanguage(language);
	const currentLanguage = getGoogleTranslateCookieLanguage();
	console.log('Changing language to:', nextLanguage);

	await syncGoogleTranslateLanguage(nextLanguage);

	if (currentLanguage !== nextLanguage) {
		window.setTimeout(() => {
			window.location.reload();
		}, 150);
	}

	return nextLanguage;
};

export const getStoredLanguage = () => {
	return getSupportedLanguage(localStorage.getItem(GOOGLE_TRANSLATE_STORAGE_KEY));
};

export const isGoogleTranslateActive = () => getStoredLanguage() !== LANG.EN.lng;
